import { Button, Paragraph, PlusIcon, TrashIcon } from '@quickmd-llc/design-system'

type Props = {
  onAddVisitType: () => void
  onDeleteService: () => void
  onCancel: () => void
  onSave: () => void
}

/**
 * Edit-mode footer: the dashed "Add visit type" tile and the fixed bottom action bar.
 * Only rendered while in edit mode (the orchestrator gates it).
 *
 * SCSS → Tailwind mapping ($border-color = var(--border-card) = shade[10] = #141E1F1A):
 *   .ns-add-visit-type -> flex items-center justify-center w-full p-sp-2 bg-white
 *                         border-[1.5px] border-dashed border-shade-10 rounded-large
 *     (1.5px dashed border width has no DS token -> arbitrary border-[1.5px])
 *   .ns-action-bar -> fixed bottom-0 left-[var(--nav-width)] right-0 flex items-center justify-end
 *                     gap-sp-1.5 py-sp-2 px-sp-3 bg-white border-t border-shade-10 z-[100]
 *     (left:var(--nav-width) is a layout var, not a DS token -> arbitrary left-[var(--nav-width)];
 *      z-index 100 -> arbitrary z-[100])
 */
export const ViewServiceFooter = ({ onAddVisitType, onDeleteService, onCancel, onSave }: Props) => (
  <>
    <div className='flex w-full items-center justify-center rounded-large border-[1.5px] border-dashed border-shade-10 bg-white p-sp-2'>
      <Button priority='tertiary' size='s' onClick={onAddVisitType}>
        <PlusIcon iconSize='s' />
        Add visit type
      </Button>
    </div>
    <div className='flex items-center justify-between rounded-large border border-shade-10 bg-white px-sp-3 py-sp-2'>
      <div className='flex flex-col gap-sp-0.5'>
        <Paragraph size='sm' className='m-0 font-semibold text-text-dark'>
          Delete this service type
        </Paragraph>
        <Paragraph size='xs' className='m-0 text-text-light'>
          Permanently removes this service type and all visit types. Existing bookings preserved.
        </Paragraph>
      </div>
      <div className='[&_button:hover]:text-text-error [&_button:hover_svg]:text-text-error'>
        <Button priority='secondary' theme='danger' size='m' onClick={onDeleteService}>
          <TrashIcon iconSize='m' />
          Delete service
        </Button>
      </div>
    </div>
    <div className='fixed bottom-0 left-[var(--nav-width)] right-0 z-[100] flex items-center justify-end gap-sp-1.5 border-t border-shade-10 bg-white px-sp-3 py-sp-2'>
      <Button priority='secondary' size='s' onClick={onCancel}>
        Cancel
      </Button>
      <Button priority='primary' size='s' onClick={onSave}>
        Save changes
      </Button>
    </div>
  </>
)
